<template>
  <BaseNew
    @new-confirm-action="createEntry"
    @new-cancel-action="resetForm"
    @new-open-action="loadServerEntry"
    @clear-form-errors="clearFormErrors"
    ref="baseNew"
    width="50%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :modelNameSingular="modelNameSingular"
  >
    <template slot="newForm">
      <Form
        ref="form"
        :entry="entry"
        :extraData="extraData"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseNew>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseNew from "../../shared/base_new.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      entry: null,
      formErrors: [],
      extraData: null,
    };
  },
  props: {
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseNew: BaseNew
  },
  methods: {
    loadServerEntry: function() {
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_NEW_CHART_OF_ACCOUNT_QUERY,
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.entry = response.data.globalContext.chartOfAccount;
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    createServerEntry: function(chartOfAccount) {
      // console.log("chartOfAccount", chartOfAccount, this.entry.validations, this.deepFilterEntryWithAllowedFieldsForMutation(chartOfAccount, this.entry.validations));
      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: CREATE_CHART_OF_ACCOUNT_MUTATION,
          variables: {
            input: this.deepFilterEntryWithAllowedFieldsForMutation(chartOfAccount, this.entry.validations)
          }
        })
        .then(response => {
          var errors = response.data.createChartOfAccount.errors

          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseNew.closeDialog();
            this.$emit("entry-created");
            this.resetForm();
          }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError){
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors){
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    createEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.createServerEntry(this.entry);
      }
    },
    resetForm: function() {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const LOAD_NEW_CHART_OF_ACCOUNT_QUERY = gql `
  {
    globalContext {
      chartOfAccount {
        code
        name
        parentId
        parent {
          id
          code
          name
          text
        }
        validations
      }
    }
  }
`;

const CREATE_CHART_OF_ACCOUNT_MUTATION = gql `
  mutation($input: ChartCreateInputObject!) {
    createChartOfAccount(input: $input) {
      chart {
        id
      }
      errors
    }
  }
`;

</script>

<style scoped></style>

<!--
createPerson(
	input: {
    kind: 1,
    cnpj: "00000000000000",
    isCollaborator: false,
    isCustomer: false,
    isSupplier: true,
    isCarrier: true,
    name: "philips programmator",
    tradingName: "Pessoa",
    taxReceiptEmail: "philips_programmator@agrosim.com.br",
    addressesAttributes: [
      {
        postalCode: "93900000",
        cityId: 1100015,
        street: "Logradouro",
        neighborhood: "Bairro",
        number: "Nº",
        complement: "Complemento",
      }
    ]
}) {
  person {
    id
  }
  errors
}
 -->
